import { CreateBudgetRequestRequest } from '../types';

/**
 * Creates a budget request based on project information
 * @param brgId - The BRG ID
 * @param projectName - The project name
 * @param budget - The budget amount
 * @param eventDate - The project event date
 * @param isAdmin - Whether the user is an admin
 * @returns CreateBudgetRequestRequest data or null if no budget
 */
export function createBudgetRequestFromProject(
  brgId: number,
  projectName: string,
  budget: number | undefined,
  eventDate: string
): CreateBudgetRequestRequest | null {
  if (!budget || budget <= 0) {
    return null;
  }

  // Extract fiscal year from event date if available
  let fiscalYear: string | undefined;
  if (eventDate) {
    try {
      const year = new Date(eventDate).getFullYear();
      fiscalYear = year.toString();
    } catch (e) {
      // If date parsing fails, skip fiscal year
    }
  }

  return {
    brgId,
    fiscalYear,
    projectEvent: projectName,
    purposeDescription: `Budget for ${projectName}`,
    requestAmount: budget,
    scheduledDate: eventDate,
  };
}

/**
 * Determines the status for a new budget request based on user role
 * @param isAdmin - Whether the user is an admin
 * @returns 'Approved' for admins, 'Pending' for leads
 */
export function getBudgetRequestStatus(isAdmin: boolean): string {
  return isAdmin ? 'Approved' : 'Pending';
}
